import { render, staticRenderFns } from "./AddNewMemberId.vue?vue&type=template&id=0f722e86&"
import script from "./AddNewMemberId.vue?vue&type=script&lang=js&"
export * from "./AddNewMemberId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports